spApp.directive('resourceDokDirective', ['$http', function ($http) {
  return {
    restrict: 'E',
    templateUrl: '/views/filters/resource-dok-filter.html',
    scope: {
      selectedDok: '='
    },
    link: function ($scope) {
      $http.get('/resources/dokLevels').then(function (response) {
        $scope.dokLevels = response.data;
      }, function (data) {
        console.error(data);
      });
      $scope.dokLevelChanged = function () {
        $scope.selectedDok = $scope.dokLevels.filter(function (item) {
          return item.selected;
        }).map(function (item) {
          return item.id;
        });
      };
    }
  };
}]);
